/* eslint-disable no-await-in-loop */
const MaxRetryCount = 100;
const DelayInMs = 1000;

export default async <Type>(func: () => Promise<Type>, shouldRetry: (obj: Type) => boolean) => {
  for (let i = 0; i < MaxRetryCount; i++) {
    let result;
    try {
      result = await func();
      // eslint-disable-next-line no-empty
    } catch {}

    if (result && !shouldRetry(result)) {
      return result;
    }

    await new Promise((r) => setTimeout(r, DelayInMs));
  }

  throw new Error(`Reached maximum of ${MaxRetryCount} retries with ${DelayInMs / 1000}s delay.`);
};
